class RegisterPage extends HTMLElement {
    constructor() {
        super(), this.birthdate = this.querySelector("#Birthdate"), this.init()
    }
    init() {
        "undefined" != typeof VMasker ? VMasker(this.birthdate).maskPattern("99/99/9999") : setTimeout((() => {
            this.init()
        }), 100)
    }
}
customElements.define("register-page", RegisterPage);
class AccountHeader extends HTMLElement {
    constructor() {
        super();

        this.customerId = this.getAttribute("data-customer");
        this.customerIsSubscriber = this.getAttribute("data-customer-is-subscriber") === "true";
        this.onlySubscribers = this.getAttribute("data-only-subscribers") === "true";
        this.devMode = this.getAttribute("data-dev-mode") === "true";

        console.log(`Customer ID: ${this.customerId}`);
        console.log(`Customer is subscriber: ${this.customerIsSubscriber}`);
        console.log(`Dev mode: ${this.devMode}`);

        if (this.devMode) return;

        if (!this.customerId) {
            window.location.href = "/account/login";
        } else if (this.onlySubscribers && !this.customerIsSubscriber) {
            window.location.href = "/account";
        }
    }
}
customElements.define("account-header", AccountHeader);
class AccountAddresses extends HTMLElement {
    constructor() {
        super(), this.initCustomerAddressForm()
    }
    initCustomerAddressForm() {
        var e = document.getElementById("AddressNewForm"),
            t = document.getElementById("AddressNewButton");
        e && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
            hideElement: "AddressProvinceContainerNew"
        }), document.querySelectorAll(".address-country-option").forEach((function(e) {
            var t = e.dataset.formId,
                s = "AddressCountry_" + t,
                r = "AddressProvince_" + t,
                o = "AddressProvinceContainer_" + t;
            new Shopify.CountryProvinceSelector(s, r, {
                hideElement: o
            })
        })), document.querySelectorAll("[data-address-new]").forEach((function(s) {
            s.addEventListener("click", (function() {
                var s = "true" === t.getAttribute("aria-expanded");
                e.classList.toggle("hidden"), t.setAttribute("aria-expanded", !s), t.focus()
            }))
        })), document.querySelectorAll("[data-address-edit]").forEach((function(e) {
            e.addEventListener("click", (function(e) {
                var t = e.target.dataset.addressEdit,
                    s = document.getElementById("EditFormButton_" + t),
                    r = document.getElementById("EditAddress_" + t),
                    o = "true" === s.getAttribute("aria-expanded");
                r.classList.toggle("hidden"), s.setAttribute("aria-expanded", !o), s.focus()
            }))
        })), document.querySelectorAll("[data-address-delete-form]").forEach((function(e) {
            e.addEventListener("click", (function(e) {
                e.preventDefault();
                var t = e.target.dataset.target,
                    s = e.target.dataset.confirmMessage;
                confirm(s || "Are you sure you wish to delete this address?") && Shopify.postLink(t, {
                    parameters: {
                        _method: "delete"
                    }
                })
            }))
        })))
    }
}
customElements.define("account-addresses", AccountAddresses);